export { nombreSede } from '../../utils/turnos';

export const money = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 });

export const coberturaTone = (tipo) => {
  const t = (tipo || '').toLowerCase();
  if (t.includes('total') || t.includes('cubiert')) return 'success';
  if (t.includes('parcial')) return 'warning';
  return 'neutral';
};